(function () {
    // Variables
    var commentField = document.getElementById('comments');

    // Functions
    
    // Function for executing code on document ready
    function domReady(callback) {
        if (['interactive', 'complete'].indexOf(document.readyState) >= 0) {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }

    // Function for updating character count on Product pages comment field
    function updateCharCount() {
        const maxLength = 255;
        const charCountDisplay = document.getElementById('charCount');
        const currentLength = commentField.value.length;
        
        charCountDisplay.textContent = `${maxLength - currentLength} characters remaining`;
    }

    // Execute JavaScript on document ready
    domReady(function () {
        if (!document.body) {
            return;
        } else {
            // Function dependent on comment field
            if (commentField) {
                commentField.addEventListener('input', updateCharCount);
            }
        }
    });
})();